import { useState } from "react";
import Landing from "./views/Landing/Landing";
import WidgetContainer from "./views/WidgetContainer/WidgetContainer";
import { VIEWS } from "./utils/constants";

type View = (typeof VIEWS)[keyof typeof VIEWS];
export default function App() {
  const [view, setView] = useState<View>(VIEWS.LANDING);

  const handleChangeView = (viewSelect: View) => {
    setView(viewSelect);
  };

  return (
    <div className="min-h-screen bg-white">
      {view === VIEWS.LANDING && (
        <Landing handleChangeView={handleChangeView} />
      )}
      {view === VIEWS.WIDGET && <WidgetContainer />}
    </div>
  );
}
